

export enum EAnalysisStatus {
  PENDING = "pending",
  IN_PROGRESS = "in_progress",
  DONE = "done",
  FAILED = "failed",
  NOT_FOUND = "not_found",
  IDLE= "idle",
}

export enum EAnalysisStages {
  VALIDATING = "validating",
  CRAWLING_PROFILE = "crawling_profile",
  CRAWLING_JOB = "crawling_job",
  ANALYZING_JOB = "processing_job",
  AI_ANALYSIS = "ai_analysis",
  CRAWLING_EMAILS = "crawling_emails",
  COMPLETING = "completing",
  COMPLETED = "completed",
}

export enum ESubscriptionPlan {
  NONE = 'none',
  FREE = 'free',
  STARTER = 'starter',
  PROFESSIONAL = 'professional',
  EXECUTIVE = 'executive',
}

export enum ECreditsFeature {
  ANALYZE_JOB = 'analyzeJob',
  TRACK_APPLICATIONS = 'trackApplications',
  ANALYZE_LINKEDIN_PROFILE = 'analyzeLinkedInProfile',
  ANALYZE_RECRUITER_LENSE = 'analyzeRecruiterLense',
  GENERATE_TARGETED_CV= 'generateTargetedCV',
}

export enum EFeatures {
  VIEW_HIRING_TEAM_EMAILS = 'viewHiringTeamEmails',
  VIEW_JOB_SALARY = 'viewJobSalary',
  TRACK_APPLICATIONS = 'trackApplications',
  PROFILE_PREFERENCES = 'profilePreferences',
  ANALYZE_LINKEDIN_PROFILE = 'analyzeLinkedInProfile',
  ANALYZE_RECRUITER_LENSE = 'analyzeRecruiterLense',
  GENERATE_TARGETED_CV= 'generateTargetedCV',
  ANALYZE_JOB = 'analyzeJob',
}

export const CREDITS_FEATURE_COST = {
  [ECreditsFeature.ANALYZE_LINKEDIN_PROFILE]: 5,
  [ECreditsFeature.ANALYZE_JOB]: 5,
  [ECreditsFeature.TRACK_APPLICATIONS]: 5,
  [ECreditsFeature.ANALYZE_RECRUITER_LENSE]: 5,
  [ECreditsFeature.GENERATE_TARGETED_CV]: 5,
}

export enum ECVGenerationStages {
  VALIDATING = "validating",
  AI_ANALYSIS = "ai_analysis",
  GENERATING_ATS_CV = "generating_ats_cv",
  COMPLETING = "completing",
  COMPLETED = "completed",
}
